export const transformServices = (
  partnerServices: string[] | null,
  partnerAdditionalServices: string[] | null,
  partnerServiceLabelsMap: Map<string, string>,
): string[] => {
  const relevantServices: string[] = [...partnerServiceLabelsMap.keys()];
  const services_array = partnerServices || [];
  const additional_services = partnerAdditionalServices || [];

  let services = services_array
    .filter((value: string) => relevantServices.includes(value))
    .map((service: string) => partnerServiceLabelsMap.get(service))
    .filter((label: string | undefined): label is string => !!label && label.trim() !== '');

  if (additional_services.length > 0) {
    const additionalServices = additional_services
      .map((service: string) => {
        const label = partnerServiceLabelsMap.get(service);
        if (label === undefined) {
          return service;
        }
        return label;
      })
      .filter((label: string | undefined): label is string => !!label && label.trim() !== '');

    services = [...services, ...additionalServices];
  }

  return services;
};
